import SupplierList from './List'
import SupplierEdit from './Edit'
import SupplierCreate from './Create'

export default {
  list: SupplierList,
  edit: SupplierEdit,
  create: SupplierCreate
}
